import { render } from "./DynamicTest.vue?vue&type=template&id=5ccc79fb&scoped=true"
import script from "./DynamicTest.vue?vue&type=script&lang=js"
export * from "./DynamicTest.vue?vue&type=script&lang=js"

import "./DynamicTest.vue?vue&type=style&index=0&id=5ccc79fb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ccc79fb"],['__file',"src/views/ProductDiagnosis/components/DynamicTest.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ccc79fb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ccc79fb', __exports__)) {
    api.reload('5ccc79fb', __exports__)
  }
  
  module.hot.accept("./DynamicTest.vue?vue&type=template&id=5ccc79fb&scoped=true", () => {
    api.rerender('5ccc79fb', render)
  })

}


export default __exports__